<template>
	<v-btn-toggle borderless group id="button-groups">
		<v-btn v-if="isAdmin" color="info" to="/admin/users" nav class="first-mobile mobile-button mx-0">
			<v-icon color="secondary" left>mdi-account-cog</v-icon> User administration
		</v-btn>
		<!-- FILE COLLECTIONS -->
		<v-btn color="info" to="/documents/PAC" nav class="first-mobile mobile-button pa-4 mx-0" v-if="checkRoleVisibility(['PAC_User','PAC_TEWG_USER', 'PAC_Admin'])">
			<v-icon color="secondary" left>mdi-folder-key</v-icon>
			File Library PAC
		</v-btn>
		<v-btn
			to="/documents/TEWG"
			color="info"
			nav
			class="mobile-button pa-4 mx-0"
			v-if="checkRoleVisibility(['TEWG_User', 'PAC_TEWG_USER','TEWG_Admin'])"
		>
			<v-icon color="secondary" left>mdi-folder-key</v-icon>
			File Library TEWG
		</v-btn>
	</v-btn-toggle>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'AppNavInternalRoutes',
	computed: {
		...mapGetters(['isAdmin', 'userRoles'])
	},
	methods: {
		checkRoleVisibility(roleKeys) {
			// Admin can see all
			if (this.isAdmin) return true
			return roleKeys.some((key) => this.userRoles.includes(key))
		}
	}
}
</script>

<style lang="scss" scoped>

@media all and (max-width: 960px) {
	#button-groups{		
		z-index: 999;
		width: 100%;
		height: 140px;
		display: initial !important;
	}
	.mobile-button{
		width: 100%;
		float:left;
	}
	.first-mobile{
		margin-top: 15px !important;
	}
  }

</style>